import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: 'AIzaSyD_n_ZV844bVCyL5QfBmllrhFCyFblbblg',
    authDomain: 'cyphr-systems-void.firebaseapp.com',
    projectId: 'cyphr-systems-void',
    storageBucket: 'cyphr-systems-void.firebasestorage.app',
    messagingSenderId: '1023927974527',
    appId: '1:1023927974527:web:614980f264f4c3c47e9d4a',
    measurementId: 'G-K596BP96ZJ',
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

export { db };